export class DetectedFormat {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "format",
            "baseName": "format",
            "type": "DetectedFormatType",
            "format": ""
        },
        {
            "name": "confidence",
            "baseName": "confidence",
            "type": "number",
            "format": ""
        },
        {
            "name": "sampled",
            "baseName": "sampled",
            "type": "number",
            "format": ""
        },
        {
            "name": "requiresSchemaRegistry",
            "baseName": "requiresSchemaRegistry",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "schemaIds",
            "baseName": "schemaIds",
            "type": "Array<number>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DetectedFormat.attributeTypeMap;
    }
    constructor() {
    }
}
